import Table from 'bee-table'

export default Table
